import { useEffect } from 'react'
import { Layout, Spin } from 'antd'
import { Navigate, Outlet, useLocation } from 'react-router-dom'
import Topbar from './Topbar'
import SidebarNav from './SidebarNav'
import { useUIStore } from '@/stores/uiStore'
import { useAuthStore } from '@/stores/authStore'

const { Sider, Content } = Layout

export default function AppLayout() {
  const { sidebarCollapsed } = useUIStore()
  const location = useLocation()
  const { authInitialized, authLoading, isAuthenticated, mustChangePassword } = useAuthStore()

  useEffect(() => {
    useAuthStore.getState().initializeAuth()
  }, [])

  if (!authInitialized || authLoading) {
    return (
      <div style={{ minHeight: '100vh', display: 'grid', placeItems: 'center', background: '#f5f5f5' }}>
        <Spin />
      </div>
    )
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />
  }

  if (mustChangePassword && location.pathname !== '/account/password') {
    return <Navigate to="/account/password" replace state={{ from: location.pathname }} />
  }

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <Topbar />
      <Layout>
        <Sider
          className="app-sider"
          width={200}
          collapsed={sidebarCollapsed}
          theme="light"
          style={{ borderRight: '1px solid #f0f0f0' }}
        >
          <SidebarNav />
        </Sider>
        <Content style={{ background: '#f5f5f5', padding: 16, minHeight: 'calc(100vh - 48px)' }}>
          <div style={{ background: '#fff', borderRadius: 6, padding: 16, minHeight: '100%' }}>
            <Outlet />
          </div>
        </Content>
      </Layout>
    </Layout>
  )
}
